// react
import { useCallback, useEffect, useState } from "react";

// kendo
import kendo from "@progress/kendo-ui";

// css
import styles from './location_mobile.module.css';

const LocationLogMobile = ({ conn, item, index, lastIndex, location }) => {
  const imgNumber = "/images/mobile/marker/marker" + (lastIndex - (index - 1)) + ".png";
  const imgFace = location.state.userGender === "M" ? "/images/mobile/marker/30_man.png" : "/images/mobile/marker/30_woman.png";

  // 시간 포맷
  const formatGathDtm = () => {

    const hour = parseInt(item.gathDtm.slice(11, 13), 10);
    const period = hour < 12 ? "오전 " : "오후 ";
    const periodHour = (hour % 12 || 12).toString().padStart(2, "0");
    const minute = new Date(item.gathDtm).getMinutes();

    return period + periodHour + "시 " + minute + "분";
  }

  useEffect(() => {
  }, []);

  return (
    <div className={styles.leftItem}>
      <div className={styles.locationLogListLeftLeft}>
        {
          index === 0 ?
          <img style={{marginTop: "0.5vh", height: "31px", width: "31px"}} src={imgFace}></img>
          :
          <img style={{marginTop: "0.5vh"}} src={imgNumber}></img>
        }
      </div>
      <div className={styles.locationLogListLeftRight}>
        <div className={styles.listGathDtm}>{formatGathDtm()}</div>
        <div className={styles.listAddress}>{item.address}</div>
      </div>
    </div>
  );
};
export default LocationLogMobile;
